import React from "react";

const CorporateNotice = () => {
  return (
    <div
      id="corporate-notice"
      style={{
        maxWidth: "860px",
        margin: "0 auto 0",
        padding: "16px 28px",
        borderRadius: "10px",
        background: "var(--brand-light)",
        border: "1px solid rgba(10, 147, 150, 0.28)",
        textAlign: "center",
        fontSize: "14px",
        color: "var(--navy)",
        lineHeight: "1.65",
      }}
    >
      <span style={{ fontWeight: "700", color: "var(--brand)" }}>
        Corporate Access Notice:{" "}
      </span>
      To unlock corporate privileges, make at least{" "}
      <span style={{ fontWeight: "700" }}>10 orders</span> using the{" "}
      <a
        href="https://play.google.com/store/apps/details?id=com.MrTruck"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: "var(--brand)",
          fontWeight: "700",
          textDecoration: "none",
        }}
        onMouseOver={e => (e.currentTarget.style.textDecoration = "underline")}
        onMouseOut={e => (e.currentTarget.style.textDecoration = "none")}
      >
        Mr Truck App
      </a>.
    </div>
  );
};

export default CorporateNotice;
